// extracted by mini-css-extract-plugin
export var button = "_63-4";
export var hasDarkBackground = "_63-7";
export var hasLightBackground = "_63-6";
export var iconWrapper = "_63-0";
export var large = "_63-2";
export var medium = "_63-1";
export var small = "_63-5";
export var xsmall = "_63-3";